<div class="left-nav h-100">
  <ul class="nav flex-column" id="nav-left-list">
    <ng-content></ng-content>
  </ul>
</div>